import { render, staticRenderFns } from "./PosterForm.vue?vue&type=template&id=20b9b661&scoped=true&"
import script from "./PosterForm.vue?vue&type=script&lang=js&"
export * from "./PosterForm.vue?vue&type=script&lang=js&"
import style0 from "./PosterForm.vue?vue&type=style&index=0&id=20b9b661&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b9b661",
  null
  
)

export default component.exports